<template>
  <v-row dense>
    <v-col>
      <v-card>
        <v-alert
          dense
          colored-border
          color="success"
          :border="surgeryIndicationProsthesis.chosen ? 'left' : null"
        >
          <v-container fluid pa-0>
            <v-row>
              <v-col>
                <v-row dense>
                  <v-col class="font-weight-bold">
                    Fabricante
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ prosthesis.manufacturer.name }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="font-weight-bold">
                    Tipo
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ prosthesis.prosthesisType.name }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="font-weight-bold">
                    Modelo
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ prosthesis.name }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col>
                <v-row dense>
                  <v-col class="font-weight-bold">
                    Dioptria
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ surgeryIndicationProsthesis.diopter }}
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="auto">
                <authorization
                  permissionKey="attendance_surgery_indication"
                  can="save"
                  v-slot:default="{ authorization }"
                >
                  <v-btn small icon v-if="authorization && allowEdit" @click="toggleChosen">
                    <v-icon :color="surgeryIndicationProsthesis.chosen ? 'success' : ''">
                      ri-check-double-line
                    </v-icon>
                  </v-btn>
                </authorization>

                <authorization
                  permissionKey="attendance_surgery_indication"
                  can="save"
                  v-slot:default="{ authorization }"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        v-if="authorization && allowEdit"
                        @click="editSurgeryIndicationProsthesis"
                      >
                        <v-icon>eva-edit-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Editar
                    </span>
                  </v-tooltip>
                </authorization>

                <authorization
                  permissionKey="attendance_surgery_indication"
                  can="delete"
                  v-slot:default="{ authorization }"
                >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        icon
                        :attrs="attrs"
                        v-on="on"
                        @click="deleteSurgeryIndicationProsthesis"
                        v-if="authorization && allowDelete"
                      >
                        <v-icon>eva-trash-outline</v-icon>
                      </v-btn>
                    </template>

                    <span>
                      Excluir
                    </span>
                  </v-tooltip>
                </authorization>
              </v-col>
            </v-row>

            <v-row dense>
              <v-col>
                <v-row dense>
                  <v-col class="font-weight-bold">
                    Observações
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col>
                    {{ surgeryIndicationProsthesis.observation }}
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-alert>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: "ProsthesisListItem",
    props: {
      surgeryIndication: Object,
      surgeryIndicationProsthesis: Object,
      editProsthesis: {
        type: Function,
        default: () => {},
      },
      allowDelete: Boolean,
      allowEdit: Boolean,
    },

    computed: {
      prosthesis() {
        return this.surgeryIndicationProsthesis.prosthesis;
      },
    },
    methods: {
      deleteSurgeryIndicationProsthesis() {
        if (confirm("Você realmente deseja deletar essa prótese?")) {
        return this.apolloMutate({
          mutation: require("@/graphql/surgery_indication/delete_prosthesis_surgery_indication.gql"),
          variables: {
            surgeryIndicationProsthesisId: this.surgeryIndicationProsthesis.id,
          },
        }).then(() => {
          this.$store.dispatch("createNotification", {
              message: "Prótese deletada com sucesso.",
              type: "success",
            });
        });
        }
      },
      editSurgeryIndicationProsthesis() {
        this.editProsthesis(this.surgeryIndicationProsthesis);
      },
      toggleChosen() {
        return this.apolloMutate({
          mutation: require("@/graphql/surgery_indication/save_prosthesis_surgery_indication.gql"),
          variables: {
            surgeryIndicationId: this.surgeryIndication.id,
            prosthesisId: this.prosthesis.id,
            surgeryIndicationProsthesisId: this.surgeryIndicationProsthesis.id,
            diopter: this.surgeryIndicationProsthesis.diopter,
            observation: this.surgeryIndicationProsthesis.observation,
            chosen: !this.surgeryIndicationProsthesis.chosen,
          },
        }).then(() => {
        });
      },
    },
  };
</script>

<style lang="sass" scoped></style>
